import styled from '@styled';
import { mobile, tabletPortrait } from '../global.styles';

interface StyledGridProps {
  columns?: string;
  tabletPortraitColumns?: string;
  mobileColumns?: string;
  gap?: string;
  mobileGap?: string;
  rows?: string;
  justifyContent?: string;
  alignContent?: string;
  alignItems?: string;
  justifyItems?: string;
  textAlign?: string;
  margin?: string;
  mobileMargin?: string;
}

export const StyledGridDiv = styled('div').withConfig({
  shouldForwardProp: (prop) =>
    ![
      'tabletPortraitColumns',
      'mobileColumns',
      'mobileGap',
      'justifyContent',
      'alignContent',
      'alignItems',
      'justifyItems',
      'textAlign',
      'mobileMargin',
    ].includes(prop),
})<StyledGridProps>`
  display: grid;
  grid-template-columns: ${(props) => props.columns || 'repeat(2, 1fr)'};
  gap: ${(props) => props.gap || '16px'};
  grid-template-rows: ${(props) => props.rows || 'auto'};
  justify-content: ${(props) => props.justifyContent || 'start'};
  align-content: ${(props) => props.alignContent || 'start'};
  align-items: ${(props) => props.alignItems || 'start'};
  justify-items: ${(props) => props.justifyItems || 'start'};
  text-align: ${(props) => props.textAlign || 'left'};
  margin: ${(props) => props['data-margin'] || '0'};

  ${tabletPortrait} {
    grid-template-columns: ${(props) => props.tabletPortraitColumns || props.columns || 'repeat(2, 1fr)'};
    gap: ${(props) => props.mobileGap || props.gap || '16px'};
    margin: ${(props) => props.mobileMargin || props['data-margin'] || '0'};
  }

  ${mobile} {
    grid-template-columns: ${(props) => props.mobileColumns || props.columns || 'repeat(2, 1fr)'};
  }
`;
